module.exports = __webpack_public_path__ + "img/s4-2.30d1b7df.jpg";